import { Method } from '@rxap/utilities';
import { OpenApiMethod, HttpMethods, BaseOpenApiMethod } from '../../open-api.method';
import { ProductControllerGetProductCategoryListResponse } from '../../responses/product-controller-get-product-category-list.response';

@OpenApiMethod({
  method: HttpMethods.GET,
  apiName: 'customer',
  path: '/product/product-category',
  operationId: 'ProductController_getProductCategoryList',
  parameters: [],
})
export class ProductControllerGetProductCategoryListMethod
  extends BaseOpenApiMethod<ProductControllerGetProductCategoryListResponse>
  implements Method<ProductControllerGetProductCategoryListResponse, void>
{
  public call(): Promise<ProductControllerGetProductCategoryListResponse> {
    return super.call();
  }
}
